import { __decorate } from "tslib";
import { Model, modelRegistry } from './Model';
import { TaxRateType } from '../types';
import { LocaleOverride } from '../wrappers/I18n';
import Store from '../wrappers/Store';
export class TaxRate extends Model {
    static entity = 'tax_rates';
    static TYPE_PRODUCT = TaxRateType.product;
    static TYPE_ORDER = TaxRateType.order;
    static TYPE_TAX_ON_NET = TaxRateType.TaxOnNet;
    static TYPE_TAX_ON_TOTAL = TaxRateType.TaxOnTotal;
    static TYPE_AMONT_PER_QUANTITY = TaxRateType.AmountPerQuantity;
    id = null;
    label = null;
    name = null;
    type = null;
    rate = '0.00';
    locale = null;
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            label: this.attr(null),
            name: this.attr(null),
            type: this.attr(null),
            rate: this.attr('0.00', value => this.round(value, 2).toFixed(2)),
            locale: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }
    /**
     * Create a new model instance.
     */
    constructor(record) {
        super();
        this.$fill(record);
    }
    getRate() {
        return parseFloat(this.rate);
    }
    static getZeroTaxRate() {
        return TaxRate.all().find(taxRate => +taxRate.rate === 0);
    }
    static getTaxesDisabledTaxRate() {
        return undefined;
    }
    static productTaxRates() {
        const taxesDisabledTaxRate = TaxRate.getTaxesDisabledTaxRate();
        if (Store.get('tenant')?.venue?.taxes_enabled) {
            return TaxRate.all().filter(taxRate => taxRate.type === TaxRate.TYPE_PRODUCT && taxRate.id !== taxesDisabledTaxRate?.id);
        }
        // Outside the VAT system: the market's taxes-disabled rate, or else (Global) its 0% product rates.
        if (!taxesDisabledTaxRate) {
            return TaxRate.all().filter(taxRate => taxRate.type === TaxRate.TYPE_PRODUCT && taxRate.getRate() === 0);
        }
        return taxesDisabledTaxRate.type === TaxRate.TYPE_PRODUCT
            ? [taxesDisabledTaxRate]
            : [];
    }
}
__decorate([
    LocaleOverride
], TaxRate, "getZeroTaxRate", null);
__decorate([
    LocaleOverride
], TaxRate, "getTaxesDisabledTaxRate", null);
__decorate([
    LocaleOverride
], TaxRate, "productTaxRates", null);
export default TaxRate;
modelRegistry.register('TaxRate', TaxRate);
//# sourceMappingURL=TaxRate.js.map